import { formatDateToLocalString } from 'src/components/SidePanelTabs/MembershipInformation/subscription-details.utils';
import { PartnerHolidayEntity } from 'src/graphql/entities/partner-holiday/partner-holiday.types';
import { ChatInfoWithTimestamp } from './chat-info-messages';

export const OPTIONS_LOCALE = {
  month: 'short',
  day: '2-digit',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  hourCycle: 'h24',
} as const;

export function getPartnerHolidayMessage(
  partnerHoliday?: PartnerHolidayEntity,
  color?: string,
  hourCycle: 'h12' | 'h24' = 'h24',
) {
  if (!partnerHoliday) {
    return;
  }

  const formattedEndDate = formatDateToLocalString({
    date: partnerHoliday.holidayEnd.toISOString(),
    options: { ...OPTIONS_LOCALE, hourCycle },
  });
  const formattedStartDate = formatDateToLocalString({
    date: partnerHoliday.holidayStart.toISOString(),
    options: { ...OPTIONS_LOCALE, hourCycle },
  });

  const message = `The partner is closed from ${formattedStartDate.replace(', 24:00', '')} through ${formattedEndDate.replace(', 23:59', '')} | ${partnerHoliday.holidayName}`;

  return (
    <ChatInfoWithTimestamp
      icon="celebration"
      date={partnerHoliday.holidayEnd.toISOString()}
      message={message}
      partnerId={partnerHoliday.partnerId}
      color={color}
    />
  );
}
